<template>
    <div class="mod-config" style="height: 100%">
        <p class="listP">帮助文档</p>
        <el-collapse v-model="activeNames">
            <el-collapse-item title="有毒有害气体参数、常见应急方案及故障处理方案
" name="1">
                <img src="../../../static/img/ewm.png" alt="" style="float: left;">
            </el-collapse-item>
        </el-collapse>
        <p></p>
    </div>
</template>

<script>
export default {
    data() {
        return {
            activeNames: ['']
        };
    },
    methods: {
    }
}
</script>

<style scoped>
.listP {
    height: 50px;
    line-height: 50px;
    text-align: left;
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #bbb;
}

/deep/ .el-collapse-item__header {
    font-size: 25px;
}
</style>


// WEBPACK FOOTER //
// src/pages/helpcenter/ewm.vue